/* ============================================================
   BrainyTots A+ Content — Slider behavior
   Mirrors Amazon Premium Regimen Carousel: prev/next arrows,
   dots indicator, scroll-snap track. Native scroll handles
   touch + keyboard; JS only wires arrows + dot sync.
   ============================================================ */
(function () {
  'use strict';

  function initSlider(root) {
    var track = root.querySelector('[data-bt-slider-track]');
    var prev = root.querySelector('[data-bt-slider-prev]');
    var next = root.querySelector('[data-bt-slider-next]');
    var dotsWrap = root.querySelector('[data-bt-slider-dots]');
    if (!track) return;

    var items = Array.from(track.children);
    if (!items.length) return;

    // Build dots
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      items.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'bt-aplus__slider-dot';
        d.dataset.idx = i;
        d.setAttribute('aria-label', 'Go to step ' + (i + 1));
        dotsWrap.appendChild(d);
      });
    }

    function visibleIndex() {
      var rect = track.getBoundingClientRect();
      var center = rect.left + rect.width / 2;
      var best = 0;
      var bestDist = Infinity;
      items.forEach(function (el, i) {
        var er = el.getBoundingClientRect();
        var ec = er.left + er.width / 2;
        var d = Math.abs(ec - center);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      });
      return best;
    }

    function syncControls() {
      var idx = visibleIndex();
      if (dotsWrap) {
        Array.from(dotsWrap.children).forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    function scrollByCard(dir) {
      var first = items[0];
      if (!first) return;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      var step = first.getBoundingClientRect().width + gap;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var t = e.target.closest('[data-idx]');
        if (!t) return;
        var idx = parseInt(t.dataset.idx, 10);
        var target = items[idx];
        if (target) {
          track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        }
      });
    }

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(syncControls);
    }, { passive: true });

    window.addEventListener('resize', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(syncControls);
    });

    syncControls();
  }

  function init() {
    document.querySelectorAll('[data-bt-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
